"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageBanner;
const react_1 = __importDefault(require("react"));
const ImageBanner_module_scss_1 = __importDefault(require("./ImageBanner.module.scss"));
function ImageBanner({ logoImage, mobileImage, tabletImage, desktopImage, accessibilityText, logoAccessibilityText, }) {
    return (react_1.default.createElement("div", { className: ImageBanner_module_scss_1.default.container, "data-testid": "image-banner-container" },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { "data-testid": "image-banner-src-desktop", srcSet: desktopImage, media: "(min-width: 1024px)" }),
            react_1.default.createElement("source", { "data-testid": "image-banner-src-tablet", srcSet: tabletImage, media: "(min-width: 600px)" }),
            react_1.default.createElement("img", { "data-testid": "image-banner-image", src: mobileImage, className: ImageBanner_module_scss_1.default.bannerImage, alt: accessibilityText })),
        react_1.default.createElement("img", { className: ImageBanner_module_scss_1.default.logo, alt: logoAccessibilityText, src: `${logoImage}?fmt=auto`, "data-testid": "adtech-banner-logo" })));
}
